import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_GAMES,
  GET_GETGAMES,
  GET_TRANSACTIONS,
  EDIT_TRANSACTION,
  GAME_MAINTENANCE,
  GAME_VERSION,
  MAINTENANCE_ALL_SOCKET,
  MAINTENANCE_GAMES_SOCKET,
  EDIT_DEMO_URL,
  GET_GAMES_RTP_LIST,
  UPDATE_RTP,
  M_POST,
  M_GET,
  GET_RISK_MANAGEMENT_LIST,
  UPDATE_CONFIGS_RISK,
  EDIT_VERSION_MASCOT, UPDATE_AGENT_RTP,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'game' })
export default class Game extends VuexModule {
  game: any = [];

  @Mutation
  mutateGame(game: any) {
    this.game = game;
  }

  @Action({ commit: 'mutateGame' })
  FetchGame(partner: object) {
    return Vue.axios({
      url: BASE_URL + GET_GAMES,
      data: partner,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateGame' })
  FetchGetGame() {
    return Vue.axios({
      url: BASE_URL + GET_GETGAMES,
      method: M_GET,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  GameMaintenance(status) {
    return Vue.axios({
      url: BASE_URL + GAME_MAINTENANCE,
      data: status,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  GameVersion(url) {
    return Vue.axios({
      url: BASE_URL + GAME_VERSION,
      data: url,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditDemoUrl(url) {
    return Vue.axios({
      url: BASE_URL + EDIT_DEMO_URL,
      data: url,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  MaintenanceAllSocket(isMaintenance) {
    return Vue.axios({
      url: BASE_URL + MAINTENANCE_ALL_SOCKET,
      data: isMaintenance,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  MaintenanceGamesSocket(isMaintenance) {
    return Vue.axios({
      url: BASE_URL + MAINTENANCE_GAMES_SOCKET,
      data: isMaintenance,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchVersionControl() {
    return Vue.axios({
      url: BASE_URL + GET_TRANSACTIONS,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditVersion(_data) {
    return Vue.axios({
      url: BASE_URL + EDIT_TRANSACTION,
      data: _data,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditVersionMascot(_data) {
    return Vue.axios({
      url: BASE_URL + EDIT_VERSION_MASCOT,
      data: _data,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchGameRtpList() {
    return Vue.axios({
      url: BASE_URL + GET_GAMES_RTP_LIST,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditUpdateRtp(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_RTP,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateAgentRTP(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_AGENT_RTP,
      data: params,
      method: M_POST,
    }).then(({ data }) => {
      const { code, message } = data.status;
      if (code === 0) {
        return data.status;
      } else {
        throw message;
      }
    })
      .catch((err) => err);
  }

  @Action
  FetchRiskManagementList(query) {
    return Vue.axios({
      url: BASE_URL + GET_RISK_MANAGEMENT_LIST,
      method: M_POST,
      data: query,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateRiskManagementConfigs(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_CONFIGS_RISK,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
